import React, { useContext, useEffect, useState } from "react";
import { Drawer, Grid, IconButton, makeStyles, Tooltip, Typography } from "@material-ui/core";
import { Group } from "@material-ui/icons";
import { teamAnalyticsSelector } from "../../redux/selectors";
import { useDispatch, useSelector } from "react-redux";
import { loadTeamAnalytics } from "../../redux/actions";
import { Skeleton } from "@material-ui/lab";
import { CaseAllocationTile } from "./TileRenderers/CaseAllocationTile";
import { useNavigate } from "../../hooks/useNavigate";
import { HistoryContext } from "../../redux/historyContext";
const useStyles = makeStyles(theme => ({
    root: {
        padding: "20px",
        width: "500px",
        height: "100%",
        position: "relative",
    },
    heading: {
        color: "#9f9f9f",
        fontSize: "1.2em",
        fontWeight: 600,
    },
}));
export const CaseAllocation = () => {
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const teamAnalyticsState = useSelector(teamAnalyticsSelector);
    const { data, loadingState } = teamAnalyticsState;
    const { location } = useContext(HistoryContext);
    const classes = useStyles();
    const navigate = useNavigate(location);
    const navigateToFilter = (filterUrl) => navigate(filterUrl);
    const handleMenuOpen = () => {
        setIsOpen(true);
    };
    const handleMenuClose = () => {
        setIsOpen(false);
    };
    useEffect(() => {
        dispatch(loadTeamAnalytics());
    }, [dispatch]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { title: "Case allocation" },
            React.createElement(IconButton, { size: "medium", onClick: handleMenuOpen, "data-test": "case-allocation", "aria-controls": "case-allocation", "aria-haspopup": "true", style: { padding: "6px 8px" } },
                React.createElement(Group, null))),
        React.createElement(Drawer, { anchor: "right", open: isOpen, onClose: handleMenuClose },
            React.createElement("div", { className: classes.root },
                React.createElement(Grid, { container: true, spacing: 3 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { variant: "h6", className: classes.heading }, "Case allocation")),
                    loadingState === "LOADED" ? (data.map((tile, index) => {
                        return React.createElement(CaseAllocationTile, { key: index, tile: tile, navigate: navigateToFilter });
                    })) : (React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Skeleton, { variant: "text", height: 60 }),
                        React.createElement(Skeleton, { variant: "text", height: 60 }),
                        React.createElement(Skeleton, { variant: "text", height: 60 }),
                        React.createElement("br", null),
                        React.createElement(Skeleton, { variant: "rect", height: 118 }))))))));
};
